module.exports = __webpack_public_path__ + "img/alert-triangle.0c1da4a5.svg";